<template>
  <div>
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class="headingPlant">Scale Weight</md-dialog-title>

      <md-dialog-content>
        <!--<form id="top" novalidate @submit.prevent="doSaveUser">-->
        <form id="top">  
          <div class="layoutScale">
            <div>
              <h3 v-if="scaleTimeWaring" class="ErrorMessage">Scale time is in {{warningMinutes}} minutes difference!</h3>
              <h3 v-if="scaleTimeError" class="ErrorMessage">Scale data expired. Please scale again!</h3>
              <h3 v-if="scaleMasterError" class="ErrorMessage">Scale master data has issue , please contact IT!</h3>
              <h3 v-if="scaleGwygError" class="ErrorMessage">Please maintain Gross weight-yard goat first!</h3>
              <h3 v-if="scaleTwygError" class="ErrorMessage">Please maintain Tare weight-yard goat!</h3>    

              <md-card v-if="receivingWindows == '185' || receivingWindows == '187' || receivingWindows == '202'" :class="getValidationRadio('dataForm.scale')">
                <md-card-header>
                  <div class="md-title">FSI</div>
                </md-card-header>
                <md-card-content>
                  <md-radio v-model="dataForm.scale" value="1" @change="onSelect">FSI Scale 1</md-radio>
                  <md-radio v-model="dataForm.scale" value="2" @change="onSelect">FSI Scale 2</md-radio>
                  <md-radio v-model="dataForm.scale" value="0" @change="onSelect">Outside Scale</md-radio>
                </md-card-content>
              </md-card>

              <md-card v-if="receivingWindows == '186' || receivingWindows == '188' || receivingWindows == '201' || receivingWindows == '203'" :class="getValidationRadio('dataForm.scale')">
                <md-card-header>
                  <div class="md-title">Wilmington</div>
                </md-card-header>
                <md-card-content>
                  <md-radio v-model="dataForm.scale" value="3" @change="onSelect">WIL Scale 3(Front)</md-radio>
                  <md-radio v-model="dataForm.scale" value="4" @change="onSelect">WIL Scale 4(Back)</md-radio>
                  <md-radio v-model="dataForm.scale" value="0" @change="onSelect">Outside Scale</md-radio>
                </md-card-content>
              </md-card>
            </div>
          </div>

          <!-- <div v-if="getPermission.acnit.view">CCR Log ID: {{ ccrLog.logId }} </div> -->

          <!-- <div v-if="getPermission.acnit.view">
            <div class="layoutPlantShort">CCR</div>
            <div class="layoutPlant" v-if="dataForm.driverLP == ccrLog.plateNo">Plate# <md-input v-model="ccrLog.plateNo" disabled/></div>
            <div class="layoutPlant" v-if="dataForm.driverLP != ccrLog.plateNo">Plate# <md-input class="ErrorMessage" v-model="ccrLog.plateNo" disabled/></div>
            <div class="layoutPlant" v-if="dataForm.containerNo == ccrLog.containerNo">Container#: <md-input v-model="ccrLog.containerNo" disabled/></div>
            <div class="layoutPlant" v-if="dataForm.containerNo != ccrLog.containerNo">Container#: <md-input class="ErrorMessage" v-model="ccrLog.containerNo" disabled/></div>
          </div> -->

          <!-- <div v-if="getPermission.acnit.view">
            <div class="layoutPlantShort">In System</div>
            <div class="layoutPlant" v-if="mode!= 'STR' "><md-input v-model="dataForm.driverLP" /></div>
            <div class="layoutPlant" v-if="mode== 'STR' "><md-input v-model="dataForm.driverLP" disabled/></div>
            <div class="layoutPlant" v-if="mode!= 'STR' "><md-input v-model="dataForm.containerNo" /></div>
            <div class="layoutPlant" v-if="mode== 'STR' "><md-input v-model="dataForm.containerNo" disabled/></div>
          </div> -->

          <div class="layoutPlantShort"> </div>

          <!-- <div v-if="getPermission.acnit.view">  
            <div class="layoutPlant2">Scale Date CCR : <md-input v-model="ccrLog.date" disabled/></div>
            <div class="layoutPlant2">Scale Time CCR: <md-input v-model="ccrLog.time" disabled/></div>
            <div class="layoutPlant2">Total Weight CCR: <md-input v-model="ccrLog.scaleWeight" disabled/></div>
          </div> -->
          <!-- <div>
            <div class="layoutPlant2">Scale Date : <md-input v-model="item.date"/></div>
            <div class="layoutPlant2">Scale Time : <md-input v-model="item.time" /></div>
            <div class="layoutPlant2">Total Weight: <md-input v-model="item.nw" @keyup="chkGWMinMax(item)"/></div>
            <div v-if="isTareWgtScale" class="layoutPlant2">Wet Net: <md-input v-model="dataForm.wetNet" disabled/></div>
          </div> -->

          <div>
            <!-- <div v-if="dataForm.scale != '0' && dataForm.scale != '4' " class="layoutPlant2">Scale Date: <md-input v-model="item.date" disabled/></div> -->
            <!-- <div v-if="dataForm.scale == '0' || dataForm.scale == '4'" class="layoutPlant2">Scale Date: <md-input v-model="item.date" /></div> -->
            <!-- <div v-if="dataForm.scale != '0' && dataForm.scale != '4'" class="layoutPlant2">Scale Time: <md-input v-model="item.time" disabled/></div> -->
            <!-- <div v-if="dataForm.scale == '0' || dataForm.scale == '4'" class="layoutPlant2">Scale Time: <md-input v-model="item.time" /></div> -->
            <!-- <div class="layoutPlant2">Total Weight: <md-input v-model="item.nw"/></div> -->
            <!-- <div v-if="dataForm.scale != '0' && dataForm.scale != '4'" class="layoutPlant2">Total Weight: <md-input v-model="item.nw" @keyup="chkGWMinMax(item)" disabled/></div> -->
            <!-- <div v-if="dataForm.scale == '0' || dataForm.scale == '4'" class="layoutPlant2">Total Weight: <md-input v-model="item.nw" @keyup="chkGWMinMax(item)" /></div> -->

            <div class="layoutPlant2">Scale Date: <md-input v-model="item.date" :disabled="!getScaleControl(this.dataForm.scale)"/></div>
            <div class="layoutPlant2">Scale Time: <md-input v-model="item.time" :disabled="!getScaleControl(this.dataForm.scale)"/></div>
            <div class="layoutPlant2">Total Weight: <md-input v-model="item.nw" @keyup="chkGWMinMax(item)" :disabled="!getScaleControl(this.dataForm.scale)"/></div>

            <div v-if="isTareWgtScale" class="layoutPlant2">Wet Net: <md-input v-model="dataForm.wetNet" disabled/></div>
          </div>




          <div v-if="isTareWgtScale">
            <div class="layoutPlant2">AVM(%) : <md-input @keyup="doGetDryNet()" v-model="dataForm.avm"/></div>
            <div class="layoutPlant2">Moisture Deduction(LBS) : <md-input v-model="dataForm.moistDeductLBS" disabled /></div>
            <div class="layoutPlant2">Moisture Deduction(%): <md-input v-model="dataForm.moistDeductPercent" disabled /></div>
            <div class="layoutPlant2">Dry Net: <md-input v-model="dataForm.dryNet" disabled/></div>
            <div><span style="color:red"> {{ dryneterror }}</span></div>
          </div>
          <div v-if="isTareWgtScale">
            <div class="layoutPlant2">Plastic Weight  : <md-input v-model="plasticWeight" @keyup="doValidateNumber"/></div>
            <div class="layoutPlant2">Pallet Count : <md-input v-model="palletCount" @keyup="doCalPalletWgt"/></div>
            <div class="layoutPlant2">Pallet Weight : <md-input v-model="palletWeight" disabled /></div>
            <div class="layoutPlant2"> </div>
          </div>
  
          <div class="layoutAutoComplete">
            <auto-complete-master-data-select
              :class="getValidationClass('dataForm.ygNo')"
              :preparedOptions="getYgOption()"
              label="Yard Goat"
              :init-value="dataForm.ygNo"
              :on-item-changed="handleYgChanged"
              :disabled="isYGDisable"
              >
            </auto-complete-master-data-select>
          </div>

          <div class="layoutPlantWide">
            Yard Goat Weight : {{ dataForm.ygWeight }}
          </div>

          <md-dialog-actions>
            <!--
            <md-button v-if="isTareWgtScale" class="md-raised custButton" @click="doGetDryNet">
              <span class="icons-center material-icons">cancel</span>Get Net
            </md-button>
          -->
            <md-button class="md-raised custButton" @click="cancalAction">
              <span class="icons-center material-icons">cancel</span>Close
            </md-button>
            <!---
            <md-button type="submit" class="md-raised custButton">
              <span class="icons-center material-icons">create</span>Select
            </md-button>
          -->
          <md-button class="md-raised custButton" @click="checkAndSelect()" :disabled="notSelect">
              <span class="icons-center material-icons">create</span>Select
            </md-button>
          </md-dialog-actions>

          <div class="alwaysShow">
            <div>
              <md-dialog-actions>
                <md-button class="md-raised custButton" @click="readAction(null)">
                  <span class="icons-center material-icons">autorenew</span>Refresh
                </md-button>
              </md-dialog-actions>
            </div>
          </div>

          <div class="minMaxMessage">
             <h3 v-if="scaleGwminmaxError" class="ErrorMessage">Gross weight needs between 48000 and 85000!</h3>    
             <h3 v-if="scaleTwminmaxError" class="ErrorMessage">Tare weight needs between 25000 and 35000!</h3>    
             <h3 v-if="scaleNwminmaxError" class="ErrorMessage">Net weight needs between 25000 and 50000!</h3>    
             <h3 v-if="scaleWgtnummError" class="ErrorMessage">Total Weight is not a numeric!</h3>
             <h3 v-if="netwgtNegativeError" class="ErrorMessage">Wet/Dry Net is negative, info not save!!</h3>
          </div>
          <confirm-alert ref="confirmAlert"></confirm-alert>
          <!--<confirm-dialog ref="confirmDialog"></confirm-dialog>--> 
        </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
@import "../../public/chrisForm.css";

form {
  width: 850px;
  margin: 0;
}

.layoutScale {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  font-family: Roboto Slab;
  margin: auto;
}

.layoutPlantShort {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  width: 15%;
  line-height: 1.5;
  color: black;
  background-color: rgb(167, 214, 241);
  display: inline-block;
  font-family: Roboto Slab;
  margin: auto;
}

.layoutPlant {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  width: 20%;
  line-height: 1.5;
  color: black;
  background-color: rgb(185, 218, 237);
  display: inline-block;
  font-family: Roboto Slab;
  margin: auto;
}

.layoutPlant2 {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  width: 20%;
  line-height: 1.5;
  color: black;
  display: inline-block;
  background-color: rgb(246, 226, 219);
  font-family: Roboto Slab;
  margin: auto;
}

.layoutPlantWide {
  padding-left: 7px;
  width: 200px;
  color:black;
  font-family: Roboto Slab;
  margin : 0;
}

.layoutPlantWide  > h3{
 
  margin-bottom: 0;
}

.adjust{
  padding-top: 0;
  margin-top: 0;
}

.headingPlant {
  padding-top: 0;
  padding-left: 0;
  margin-bottom: 0;
  color: #3522af;
  /* width: 92%; */
  line-height: 2;
  font-size: 24px;
  font-family: Roboto Slab;
  margin-left: 10px;
}

  .md-card {
    width: 400px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }

.SpinnerAdj {
  margin-left: 30px;
}

.md-card-header {
  padding-bottom: 0;
  padding-top: 5px;
}

.layoutAutoComplete {
  width: 30%;
  padding-left: 5px;
  display: inline-block;
}

.ErrorMessage {
  color: #f14668 !important;
}

.minMaxMessage {
  position:relative; 
  left: 330px; 
  top: -150px;
  /*border: 3px solid #73AD21;*/
  width: 350px;
}

</style>
<script>
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import dateFormat from "../utils/dateFormat";
import { minLength, required, maxLength } from "vuelidate/lib/validators";
import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
import callingApiCenter from "./CallingApiCenter.vue";
//import api from "../api";
import moment from "moment";
import InitialDataVue from "../views/InitialData.vue";
import load from "../vuex/load";
import confirmAlert from './ConfirmAlert.vue'
//import confirmDialog from './ConfirmDialog.vue'

const getInitialdataForm = () => ({
  scale: null,
  ygNo: null,
  ygWeight: null,
  weight: null,
  driverLP: null,
  containerNo: null,
  seqNo: null,
  yard: null,
  inboundShipment: null,
  ibs_type: null,
  wetNet: null,
  dryNet: null,
  avm: null,
  moistDeductPercent: null,
  moistDeductLBS: null,
  originalgw: null,
  originaltw: null,
});

const getInitItem = () => ({
  channel: null,
  tran: null,
  nw: null,
  tw: null,
  unit: null,
  type: null,
  driverLP: null,
  containerNo: null,
  date: dateFormat.getLocalDateOnly(moment().toDate()),
  time: dateFormat.time(moment().toDate()),
});

// const getInitCcrLog = () => ({
//   date: null,
//   time: null,
//   office: null,
//   logId: null,
//   yard: null,
//   gateType: null,
//   gateNo: null,
//   statusType: null,
//   logDateTime: null,
//   scaleWeight: null,
//   plateNo: null,
//   containerNo: null,
//   chassisNo: null,
//   containerType: null,
//   office: "LGB",
//   plateImage: null,
//   containerImage: null,
//   chassisImage: null,
//   processType: null,
//   inboundShipment: null,
//   seqNo: null,
// });

const getInitSearchRequest = () => ({
  yard: null,
  gateType: "S",
  gateNo: null,
  statusType: null,
  logDateTime: {
    startDate: null,
    endDate: null
  },
  logStatus: null
});


export default {
  components: { AutocompleteCcicLocationSelect, callingApiCenter, confirmAlert },
  mixins: [validationMixin],
  props: {
    mode: String,
    action: Function,
  },
  data: () => ({
    showDialog: false,
    dataForm: getInitialdataForm(),
    item: getInitItem(),
    load: null,
    plasticWeight: null,
    palletCount: null,
    palletWeight: null,
    originalWetNet: null,
    originalDryNet: null,
    scaleMaster: [],
    selected: null,
    receivingWindows: '',
    scaleTimeWaring: false,
    warningMinutes: '',
    scaleTimeError: false,
    scaleMasterError: false,
    scaleGwygError: false,
    scaleTwygError: false,
    scaleGwminmaxError: false,
    scaleTwminmaxError: false,
    scaleNwminmaxError: false,
    scaleWgtnummError: false,
    netwgtNegativeError: false,
    notSelect: false,
    // ccrLog: getInitCcrLog(),
    // result: getInitCcrLog(),
    searchRequest: getInitSearchRequest(),
    needAlert: true,
    dryneterror: null,
    isTareWgtScale: false,
    isYGDisable: false,
    //originalgw: 0,
    //originaltw: 0,
    focusState: 'blurred',
    dropdownState: 'closed',
    scale0: null, 
    scale1: null,
    scale2: null,
    scale3: null,
    scale4: null,
  }),

  watch: {
    // eslint-disable-next-line
    // "dataForm.ygWeight"() {
    //   if (this.mode != "SWR") return;
    //   console.log("got ygweight change");

    //   if (this.ccrLog.scaleWeight != null) {
    //     const gross = Number(this.ccrLog.scaleWeight) - Number(this.dataForm.ygWeight);
    //     const tare = Number(this.load.tareWeight) - Number(this.load.twYgWeight);
    //     this.dataForm.weight = (gross - tare).toString();
    //   }
    // },

    // "ccrLog.scaleWeight"() {
    //   if (this.mode != "SWR") return;
    //   console.log("got scale  change");

    //   if (this.dataForm.ygWeight != null) {
    //     const gross = Number(this.ccrLog.scaleWeight) - Number(this.dataForm.ygWeight);
    //     const tare = Number(this.load.tareWeight) - Number(this.load.twYgWeight);
    //     this.dataForm.weight = (gross - tare).toString();
    //   }
    // },
  },

  computed: {
    ...mapGetters([
      "getMasterDataByGroup",
      "getMasterDataName",
      "getMasterDataAsSelectOptionByGroup",
      "getUserProfile",
      'getPermission',
    ]),
  },

  mounted() {
    // this.scaleMaster = this.getMasterDataAsSelectOptionByGroup("SCALE_MASTER");
  },

  validations: {
    dataForm: {
      scale: { required },
      ygNo: { required }
    },
  },

  methods: {
    async openDialog(existingUser, scale0, scale1, scale2, scale3, scale4) {
      this.scale0 = scale0;
      this.scale1 = scale1;
      this.scale2 = scale2;
      this.scale3 = scale3;
      this.scale4 = scale4;
      
      this.$store.commit("clearApiError");
      this.$v.dataForm.$reset();
      this.dataForm = getInitialdataForm();
      this.item = getInitItem();
      this.load = existingUser;
      console.log(`scale info bring in from inbound: ${JSON.stringify(existingUser)}`);
      //console.log("load: " + JSON.stringify(this.load));
      //console.log(this.scaleMaster);
      //console.log(this.getYgOption());
      this.isTareWgtScale = false;
      if (this.mode == "SWR") {
         this.dataForm.scale = this.load.gwStation;
         this.dataForm.ygNo = existingUser.gwYgNo;
         this.dataForm.ygWeight = existingUser.gwYgWeight;
         this.item.nw = this.convertDecToInt(this.load.vgmWeight);
         this.chkGWMinMax(this.item);
      }   
      if (this.mode == "STR") {
         this.isTareWgtScale = true;
         this.plasticWeight = existingUser.plasticWeight;
         this.palletWeight = existingUser.palletWeight;
         this.palletCount = existingUser.palletCount;
         if (existingUser.gwYgNo == "LIVELOAD")
         {
            this.dataForm.ygNo = "LIVELOAD";
            this.dataForm.ygWeight = 0;
            this.isYGDisable = true;
         } else {
            this.dataForm.ygNo = existingUser.twYgNo;
            this.dataForm.ygWeight = existingUser.twYgWeight;
            this.isYGDisable = false;
         }   
         //this.dataForm.ygWeight = existingUser.twYgWeight;
         this.dataForm.scale = this.load.twStation;
         this.item.nw = this.convertDecToInt(this.load.tareWeight);
         this.chkGWMinMax(this.item);
      }   
      this.dataForm.driverLP = existingUser.driverLP;
      this.dataForm.containerNo = existingUser.containerNo;
      this.receivingWindows = existingUser.receivingWindows;
      this.dataForm.office = existingUser.office;
      this.dataForm.yard = existingUser.receivingWindows;
      this.dataForm.seqNo = existingUser.seqNo;
      this.dataForm.inboundShipment = existingUser.inboundShipment;
      this.dataForm.ibs_type = existingUser.ibs_type;
      this.dataForm.vgmWeight = existingUser.vgmWeight;
      this.dataForm.avm = existingUser.avm;
      this.dataForm.moistDeductLBS = existingUser.moistureDedInLBS;
      console.log("eistingUser moistureDedInPercent: " + existingUser.moistureDedInPercent);
      this.dataForm.moistDeductPercent = existingUser.moistureDedInPercent;
      this.dataForm.moistDeductPercent = this.convertFloatToTwoDec(this.dataForm.moistDeductPercent);
      this.dataForm.wetNet = existingUser.wetNet;
      this.dataForm.dryNet = existingUser.dryNet;
      this.originalDryNet = existingUser.dryNet;
      this.originalWetNet = existingUser.wetNet;
      if ((existingUser.originalGW == null || existingUser.originalGW == '') && (this.load.vgmWeight && this.load.vgmWeight != '')) {
         this.dataForm.originalgw = this.load.vgmWeight;        
      } else {
         this.dataForm.originalgw = existingUser.originalGW;
      }
      if ((existingUser.originalTW == null || existingUser.originalTW == '') && (this.load.tareWeight && this.load.tareWeight != '')) {
         this.dataForm.originaltw = this.load.tareWeight;
      } else {   
         this.dataForm.originaltw = existingUser.originalTW;
      }
      //console.log("initial originalgw: " + this.dataForm.originalgw + ", originaltw: " + this.dataForm.originaltw);   
      // if (this.mode == "STR") {
      //    this.isTareWgtScale = true;
      //    this.dataForm.wetNet = this.dataForm.vgmWeight - this.item.nw;
      // }
      this.scaleTimeWaring = false;
      this.scaleTimeError = false;
      this.scaleMasterError = false;
      this.scaleGwygError = false;
      this.scaleTwygError = false;
      this.netwgtNegativeError = false;
      this.notSelect = false;
      // this.scaleGwminmaxError = false;
      // this.scaleTwminmaxError = false;
      // this.scaleNwminmaxError = false;
      // this.scaleWgtnummError = false;
      this.showDialog = true;
      this.needAlert = true;
    },

    getScaleControl(scale) {
      
      if ( scale == null )
      {
        return false;
      }

      if ( scale == "0")
      {
        if ( this.scale0.status == "OFF" )
        { 
          return true;
        }
        else
        {
          const releaseDateDiff = moment().diff(this.scale0.releaseDate , 'minutes');
          if (releaseDateDiff < Number(2))
          {
            return true;
          }
          else
          {
            return false;
          }
        }
        
      }

      if ( scale == "1")
      {
        if ( this.scale1.status == "OFF" )
        { 
          return true;
        }
        else
        {
          const releaseDateDiff = moment().diff(this.scale1.releaseDate , 'minutes');
          if (releaseDateDiff < Number(2))
          {true
            return true;
          }
          else
          {
            return false;
          }
        }
      }

      if ( scale == "2")
      {
        if ( this.scale2.status == "OFF" )
        { 
          return true;
        }
        else
        {
          const releaseDateDiff = moment().diff(this.scale2.releaseDate , 'minutes');
          if (releaseDateDiff < Number(2) )
          {
            return true;
          }
          else
          {
            return false;
          }
        }
      }

      if ( scale == "3")
      {
        if ( this.scale3.status == "OFF" )
        { 
          return true;
        }
        else
        {
          const releaseDateDiff = moment().diff(this.scale3.releaseDate , 'minutes');
          if (releaseDateDiff < Number(2))
          {
            return true;
          }
          else
          {
            return false;
          }
        }
      }

      if ( scale == "4")
      {
        if ( this.scale4.status == "OFF" )
        { 
          return true;
        }
        else
        {
          const releaseDateDiff = moment().diff(this.scale4.releaseDate , 'minutes');
          if (releaseDateDiff < Number(2))
          {
            return true;
          }
          else
          {
            return false;
          }
        }
      }

    },

    convertDecToInt(val) {
       if (val) {
          //console.log("convert: " + parseInt(val))
          return parseInt(val);
       } else {
          return val;
       }   
    },

    convertFloatToTwoDec(val) {
       if (val) {
         var retVal = parseFloat(val).toFixed(2);
         //console.log("convert float: " + retVal);
         return retVal;
       } else {
         return val;
       }
    },

    getValidationClass(fieldName) {
      const field = _(this.$v).lookup(fieldName);

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
      return {};
    },

    getValidationRadio(fieldName) {
      const field = _(this.$v).lookup(fieldName);

      if (field) {
        return {
          ErrorMessage: field.$invalid && field.$dirty,
        };
      }
      return {};
    },

    handleScaleChanged(id) {
      this.dataForm.scale = id;
    },

    handleYgChanged(id, tag, tag1, weight) {
      //console.log(weight);
      this.dataForm.ygNo = id;
      this.dataForm.ygWeight = weight;
      this.updateWetDryNet();
    },

    cancalAction() {
      this.showDialog = false;
      this.$store.commit("clearApiError");
    },

    readAction() {
      // if (this.dataForm.scale == '2'){
      //   this.getCCRLog(this.dataForm);
      // }

      this.getScale(this.dataForm.scale);
    },

    doGetDryNet() {
      //console.log("doGetDryNet");
      this.dryneterror = "";
      //if (!this.dataForm.avm || this.dataForm.avm == "")
      //   this.dryneterror = "Error: AVM is missing!";
      //console.log("avm: " + this.dataForm.avm);
      var allowanceMoist = 12;        
      if (!this.dataForm.avm || (this.dataForm.avm && this.dataForm.avm == "") || this.dataForm.avm == 12) {
        this.dataForm.moistDeductLBS = 0;
        this.dataForm.moistDeductPercent = 0;
        this.dataForm.dryNet = this.dataForm.wetNet;
      }
      if (this.dataForm.avm > 100) {
         this.dryneterror = "Error: AVM is excess 100";
      } else {   
        if (this.dataForm.avm > 12) { 
           allowanceMoist = this.dataForm.avm;
           //const p_wetnet = (this.dataForm.wetNet != null && this.dataForm.wetNet != "")? this.dataForm.wetNet : 0;
           //this.dataForm.moistDeductLBS =  p_wetnet * (allowanceMoist - 12) / 100; 
           //this.dataForm.moistDeductPercent = allowanceMoist - 12;
           //this.dataForm.dryNet = p_wetnet - this.dataForm.moistDeductLBS;
        } else {
           allowanceMoist = 12
        }
        const p_wetnet = (this.dataForm.wetNet != null && this.dataForm.wetNet != "")? this.dataForm.wetNet : 0;
        this.dataForm.moistDeductLBS = Math.round ( p_wetnet * (allowanceMoist - 12) / 100 ); 
        this.dataForm.moistDeductPercent = this.convertFloatToTwoDec(allowanceMoist - 12);
        //console.log("allowanceMoist: " + allowanceMoist);
        //console.log("moistdeductpercent:  " + this.dataForm.moistDeductPercent);
        //this.dataForm.dryNet = p_wetnet - this.dataForm.moistDeductLBS - this.plasticWeight - this.palletWeight;

        //wetnet already deduce pallet and plastic wgt so no need to double deduce
        this.dataForm.dryNet = p_wetnet - this.dataForm.moistDeductLBS;
      }
    },

    doCalPalletWgt() {
       var validationErr = false;
       var needCount = true;
       console.log(`pallet count: ${this.palletCount}`);
       if (this.palletCount == null || this.palletCount == '')
       {
         this.palletWeight = 0;
         this.updateWetDryNet();
         needCount = false;
       }
       if (!Number.isInteger(Number(this.palletCount))) {
          console.log(`pallet count is not an integer`);
          validationErr = true;
       } else {
          if (Number(this.palletCount) < 0)
          {
            console.log(`pallet count is neg num`);
            validationErr = true;
          }
       }
       if (!validationErr && needCount)
       {
          this.palletWeight = Number(this.palletCount) * 60;
          this.dataForm.wetNet = this.dataForm.wetNet - this.palletWeight;
          this.dataForm.dryNet = this.dataForm.dryNet - this.palletWeight;
          this.updateWetDryNet();
       }
    },

    doValidateNumber(e) {
      console.log(`plastic wgt: ${this.plasticWeight}`);
      console.log(`event code: ${e.key}`);
      var validationErr = false;
      //if (e.key == 'Backspace')
      //{
      //   return; 
      //}
      if (this.plasticWeight == null || this.plasticWeight == '')
      {
          //this.plasticWeight = 0;
          this.updateWetDryNet();
      }
      if (!/^-?\d+(\.\d+)?$/.test(this.plasticWeight)) {
            const p_plasticwgt = Number(this.plasticWeight); 
            console.log(`check nan: ${Number.isNaN(p_plasticwgt)}`);
            console.log(`check include period: ${p_plasticwgt.toString().includes('.')}`);
            if (Number.isNaN(p_plasticwgt) || !p_plasticwgt.toString().indexOf('.') > 0) {
              console.log(`plastic wgt is not a decimal number`);
              validationErr = true;
            } else {
              //if (this.plasticWeight.indexOf('.') == this.plasticWeight.length - 1)
              //{
              //   var p_plasticwgt = this.plasticWeight + '0';
              //   this.plasticWeight = p_plasticwgt; 
              //}
              console.log(`plastic wgt before convert: ${this.plasticWeight}`);
              //this.plasticWeight = parseFloat(this.plasticWeight);
              console.log(`plastic wgt convert to float: ${parseFloat(this.plasticWeight)}`);
            }
      } else {
           if (parseFloat(this.plasticWeight) < 0)
           {
             console.log(`plastic Wgt is neg num`);
             validationErr = true;
           }
      }
      
      if (!validationErr)
      {
          if (this.plasticWeight != null && this.plasticWeight != '')
          {
            console.log(`convert plastic wgt to float: ${parseFloat(this.plasticWeight)}`);
            
            //this.dataForm.wetNet = this.dataForm.wetNet - parseFloat(this.plasticWeight);
            //this.dataForm.dryNet = this.dataForm.dryNet - parseFloat(this.plasticWeight);
            //recal wet dry net
            this.updateWetDryNet();
          }
      } else {
          alert("Plastic weight has to be a postive decimal/integer number!"); 
      }
       
    },


    async getScale(scale) {
      this.item = getInitItem();
      if (scale == null) return;
      var url = "";
      const timeStamp = moment().unix()
      if (window.location.host == "localhost:8080") {
        switch (this.dataForm.scale) {
          case "1":
            url = "Alibi.csv?" + timeStamp;
            break;
          case "2":
            url = "Alibi2.csv?" + timeStamp;
            break;
          case "3":
            url = "Alibi.csv?" + timeStamp;
            break;
        }
      } else {
        switch (this.dataForm.scale) {
          case "1":
            url = "FSIScale/Alibi1.csv?" + timeStamp;
            break;
          case "2":
            url = "FSIScale/Alibi2.csv?" + timeStamp;
            break;
          case "3":
            url = "FSIScale/Alibi3.csv?" + timeStamp;
            break;
          // case "4":
          //   // url = "FSIScale/Alibi4.csv?" + timeStamp;
          //   date = dateFormat.getLocalDateOnly(moment().toDate())
          //   time =  dateFormat.time(moment().toDate())
          //   break;
        }
      }
      $.get(url).then((data) => {
        const item = data.split("\n", 2);
        this.parseScale(item[1]);
      });
    },

    // async getCCRLog(LogCcr) {
    //   this.ccrLog = getInitCcrLog();
    //   this.result = getInitCcrLog();
    //   if (LogCcr == null) return;

    //   const scaleDate = dateFormat.getLocalDateOnly(moment().toDate())
    //   this.searchRequest.yard = LogCcr.yard;
    //   this.searchRequest.statusType = "S";
    //   this.searchRequest.gateNo = LogCcr.scale; 
    //   this.searchRequest.logDateTime.startDate = scaleDate + "T00:00:01";
    //   this.searchRequest.logDateTime.endDate = scaleDate + "T23:59:59";

    //   const search = this.searchRequest;

    //   if (LogCcr.scale != null)
    //   {
    //     this.result = await api.post('/api/w/ccr/data/getCCRLog', search);
    //     this.result.sort((a,b) => new Date(b.logDateTime) - new Date(a.logDateTime));
    //     this.ccrLog = this.result[0]
    //     this.ccrLog.date = moment(String(this.ccrLog.logDateTime)).format('YYYY/MM/DD')
    //     this.ccrLog.time = moment(String(this.ccrLog.logDateTime)).format('hh:mm:ss')
    //     const masterData = await api.post('/api/w/masterData',{groups:["YG_MASTER"]})
    //     const masterDataf = masterData.filter( it => it.tagId == this.ccrLog.plateNo)
    //     if ( masterDataf.length > 0 ){
    //       this.dataForm.ygWeight = masterDataf[0].weight
    //       this.dataForm.ygNo = masterDataf[0].tagId; 
    //     }
    //     else{
    //       this.dataForm.ygNo = " "
    //       this.dataForm.ygWeight = " "
    //     }
    //   };


    // },

    chkGWMinMax(item) {
       //alert("check Gross Weight Min and Max: " + this.dataForm.nw);
       //console.log("chkGWMinMax " + wgt);
       //console.log("item: " + JSON.stringify(item));
       this.scaleGwminmaxError = false;
       this.scaleTwminmaxError = false;
       this.scaleNwminmaxError = false;
       this.scaleWgtnummError = false;
       const testdigit = /^[0-9]+$/.test(item.nw)
       //console.log("testdigit: " + testdigit);
       if (item.nw && item.nw != "" && !testdigit) { this.scaleWgtnummError = true; return;};
       const wgt = (item.nw)? parseInt(item.nw) : item.nw;
       if (this.mode == "SWR") { //gross wgt
          //console.log("mode: " + this.mode);
          if (item.nw && item.nw != ""
             && (wgt < 48000 || wgt > 85000)) {
              //alert("check Gross Weight Min and Max: " + wgt);
              this.scaleGwminmaxError = true;
          }

       } else { //tare wgt
         //console.log("item nw: " + wgt);
         if (item.nw && item.nw != ""
             && (wgt < 25000 || wgt > 35000)) {
              //alert("check Tare Weight Min and Max: " + wgt);
              this.scaleTwminmaxError = true;
              var netwgt = wgt;
              if (this.load.vgmWeight != null && parseInt(this.load.vgmWeight) != null)
                 netwgt = parseInt(this.load.vgmWeight) - wgt;
              //console.log("netwgt: " + netwgt);
              if (netwgt < 25000 || netwgt > 50000 ) {
                this.scaleNwminmaxError = true;
              } 
              //this.updateWetDryNet();
              // else {
              //    console.log("gw: " + this.dataForm.vgmWeight + ", tw: " + item.nw + ", netwgt: " + netwgt );
              //    //this.dataForm.wetNet = this.dataForm.vgmWeight - item.nw;
              //    this.dataForm.wetNet = netwgt;
              //    this.dataForm.dryNet = this.dataForm.wetNet - this.dataForm.moistDeductLBS;
              // }   
            } else {

              // const netwgt = parseInt(this.load.vgmWeight) - wgt;
              // //console.log("gw: " + this.dataForm.vgmWeight + ", tw: " + item.nw + ", netwgt: " + netwgt );
              // //this.dataForm.wetNet = this.dataForm.vgmWeight - item.nw;
              // this.dataForm.wetNet = netwgt;
              // this.dataForm.dryNet = this.dataForm.wetNet - this.dataForm.moistDeductLBS;
              //this.updateWetDryNet();
            }
            this.updateWetDryNet();

       }
       //console.log("gwminmaxerr: " + this.scaleGwminmaxError + ", twminmaxerr: " + this.scaleTwminmaxError);
    },

    updateWetDryNet() {
      this.notSelect = false;
      this.netwgtNegativeError = false;
      //item.nw = tare weight
      const wgt = (this.item.nw)? parseInt(this.item.nw) : this.item.nw;
      //const netwgt = parseInt(this.load.vgmWeight) - wgt;
      console.log(`item nw(tare wgt): ${wgt}`);
      //net weight = gross wgt (vgmwgt) - tare wgt (item.nw)
      var netwgt = parseInt(this.load.vgmWeight) - wgt;
      console.log(`netwgt (vgmwgt: ${this.load.vgmWeight} - net wgt (${wgt})) = ${netwgt}`);
       //if (this.dataForm.ibs_type == "Target" && this.load.gwYgWeight > 0 ) {
         // netwgt = ( parseInt(this.load.vgmWeight) - parseInt(this.load.gwYgWeight) ) - ( wgt - parseInt(this.dataForm.ygWeight) ) ;
         // console.log(this.dataForm.ibs_type + "netwgt: " + netwgt + ", gw: " + this.load.vgmWeight + ", wgt: " + wgt + this.load.gwYgWeight + this.load.twYgWeight );
       //}
       //deduce Gross and tare Yard Goat weight
      var p_grosswgt = parseInt(this.load.vgmWeight);
      var p_tarewgt = wgt;
      if (this.load.gwYgWeight != null && this.load.gwYgWeight != '' && this.load.gwYgWeight > 0) {
         //netwgt = netwgt - parseInt(this.load.gwYgWeight);
         p_grosswgt = p_grosswgt - parseInt(this.load.gwYgWeight);
      }
      console.log(`gross wgt after gw yg wgt: ${p_grosswgt}`);
      if (this.dataForm.ygWeight != null && this.dataForm.ygWeight != '' && this.dataForm.ygWeight > 0)
      {
        //console.log(`gwygwgt: ${this.load.gwYgWeight}`);
        //netwgt = netwgt - parseInt(this.dataForm.ygWeight);
        p_tarewgt = p_tarewgt - parseInt(this.dataForm.ygWeight);
      }
      console.log(`tare wgt after tw yg wgt: ${p_tarewgt}`);
      netwgt = p_grosswgt - p_tarewgt;
      console.log(`netwgt: ${netwgt}`);
      //console.log("netwgt: " + netwgt + ", gw: " + this.load.vgmWeight + ", wgt: " + wgt);
      //console.log(`gwygwgt: ${this.load.gwYgWeight} ygwgt: ${this.dataForm.ygWeight}`);

      var p_plasticwgt = this.plasticWeight;
      var p_palletwgt = this.palletWeight;
      if (this.plasticWeight == null || this.plasticWeight == '')
      {
         p_plasticwgt = 0;
         //this.plasticWeight = 0;
      }
      if (this.palletWeight == null || this.palletWeight == '')
      {
         p_palletwgt = 0;
         //this.palletCount = 0;
         //this.palletWeight = 0;
      }
      this.dataForm.wetNet = netwgt - p_plasticwgt - p_palletwgt;
      console.log(`wetnet: ${this.dataForm.wetNet} plastic wgt: ${p_plasticwgt} pallet wgt: ${p_palletwgt}`)
      //const mdlbs = (this.dataForm.moistDeductLBS && this.dataForm.moistDeductLBS != "")? this.dataForm.moistDeductLBS: 0;
      //this.dataForm.dryNet = this.dataForm.wetNet - mdlbs;
      this.doGetDryNet();
      console.log(`drynet: ${this.dataForm.dryNet}`);
      if (this.dataForm.wetNet < 0 || this.dataForm.dryNet < 0) {
         this.notSelect = true;
         this.netwgtNegativeError = true;
      }
    },

    parseScale(item) {
      const info = item.split(",");

      if(this.dataForm.scale == "0" || this.dataForm.scale == "4"){
        const infoObject = {
                date: dateFormat.getLocalDateOnly(moment().toDate()),
                time:  dateFormat.time(moment().toDate()),
                nw: 0,
                tw: 0,
        };
        this.scaleMasterError = false;
        this.scaleTimeWaring = false;
        this.scaleTimeError = false;
        this.warningMinutes = '';
        this.item = infoObject;
      }
      else{
        const infoObject = {
          date: info[0].split(" ")[0],
          time: info[0].split(" ")[1],
          channel: info[1],
          tran: info[2],
          nw: info[3],
          tw: info[4],
          unit: info[5],
          type: info[6],
        };
        this.item = infoObject;
        if (this.mode == "SWR")
          this.dataForm.originalgw = this.item.nw;
        if (this.mode == "STR")
          this.dataForm.originaltw = this.item.nw; 
        console.log("inbound scale originalgw: " + this.dataForm.originalgw + ", originaltw: " + this.dataForm.originaltw);   
        this.getScaleTimeControl();
        // this.updateWetDryNet();
      }
      this.updateWetDryNet();
    },

    getScaleTimeControl()
    {
       this.scaleMaster = this.getMasterDataAsSelectOptionByGroup("SCALE_MASTER");
       this.scaleMasterError = false;
       const scaleItem = this.scaleMaster.filter( it => it.tagId == this.dataForm.scale); 
       if (scaleItem.length != 1) 
       {
        //console.log(scaleItem);
        this.scaleMasterError = true;
        return
       }
       const scaleTime = moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time;
       const scaleTimeObject = moment(scaleTime);
       const diff = moment().diff(scaleTimeObject, 'minutes');
       if (diff > Number(scaleItem[0].errToleranceTime))
       {
         this.scaleTimeError = true;
       }
       else if (diff > Number(scaleItem[0].warnToleranceTime)){
         this.scaleTimeWaring = true;
         this.warningMinutes = scaleItem[0].warnToleranceTime;
       }
       else
       {
         this.scaleTimeWaring = false;
         this.scaleTimeError = false;
         this.warningMinutes = '';
       }
    },

    getYgOption()
    {
       if (this.receivingWindows == '185' || this.receivingWindows == '187') //FSI and FSI 3rd party
       {
           return this.getMasterDataAsSelectOptionByGroup('YG_MASTER').filter( it => it.recWindow == '185' || it.recWindow == 'ALL');
       }
       else
       {
           return this.getMasterDataAsSelectOptionByGroup('YG_MASTER').filter( it => it.recWindow == '186' || it.recWindow == 'ALL');
       }      
    },

    onSelect() {
      //console.log("test");
      // if (this.dataForm.scale != '2'){
      //   this.ccrLog.office = "LGB",
      //   this.ccrLog.logId = null,
      //   this.ccrLog.yard = null,
      //   this.ccrLog.gateType = null,
      //   this.ccrLog.gateNo = null,
      //   this.ccrLog.statusType = null,
      //   this.ccrLog.logDateTime = null,
      //   this.ccrLog.plateNo = null,
      //   this.ccrLog.plateImage = null,
      //   this.ccrLog.containerNo = null,
      //   this.ccrLog.containerType = null,
      //   this.ccrLog.containerImage = null,
      //   this.ccrLog.chassisNo = null,
      //   this.ccrLog.chassisImage = null,
      //   this.ccrLog.scaleWeight = null,
      //   this.ccrLog.processType = null,
      //   this.ccrLog.inboundShipment = null,
      //   this.ccrLog.seqNo = null,
      //   this.ccrLog.date = null,
      //   this.ccrLog.time = null
      // }

      this.getScaleControl(this.dataForm.scale);
      this.readAction();
      //this.updateWetDryNet();
    },

    async doConfirmAlert(message) {
      const ok = await this.$refs.confirmAlert.show({
         title: 'CONFRIM',
         message: message,
         okButton: 'Proceed',
         cancelButton: 'Revise',
      })      
      if (ok) {
         return 'OK';
      } else {
         return 'CANCEL';
      }
    },

    async checkAndSelect() {
      var gorevise = false;

      if (this.scaleTimeError) {
        window.alert('"Scale Data Expired! Re-Scale is required!')
        return;
      }

      if (this.scaleWgtnummError) {
         await this.doConfirmAlert("Total Weight is not a numeric, process with not select!").then ( (ret) =>{
          //console.log("retVal: " + JSON.stringify(ret));
          //this.needAlert = false;
          // if (ret == 'CANCEL') 
          //    gorevise = true;
          // if (ret == 'OK') {
          //   //alert("ret is OK");
          //   this.doSaveUser();
          // } else {
          //   //alert("ret is CANCEL");
          //   this.showDialog = true;
          // }
          if (ret == 'CANCEL') {
             this.showDialog = true;
             gorevise = true;
          }
         });
      }
      if (this.scaleGwminmaxError) {
         await this.doConfirmAlert("Gross weight needs between 48000 and 85000!").then ( (ret) =>{
          //console.log("retVal: " + JSON.stringify(ret));
          //this.needAlert = false;
          // if (ret == 'CANCEL') 
          //    gorevise = true;
          // if (ret == 'OK') {
          //   //alert("ret is OK");
          //   this.doSaveUser();
          // } else {
          //   //alert("ret is CANCEL");
          //   this.showDialog = true;
          // }
          if (ret == 'CANCEL') {
             this.showDialog = true;
             gorevise = true;
          }
         });
      }
      if (this.scaleTwminmaxError) {
         var msg = "Tare weight needs between 25000 and 35000";
         if (this.scaleNwminmaxError) {
            msg += "; Net weight needs between 25000 and 50000";
         }
         msg += "!";
         await this.doConfirmAlert(msg).then ( (ret) =>{
          //console.log("retVal: " + JSON.stringify(ret));
          //this.needAlert = false;
          // if (ret == 'CANCEL') 
          //    gorevise = true; 
          // if (ret == 'OK') {
          //    this.doSaveUser();
          // } else {
          //    this.showDialog = true;
          // }
          if (ret == 'CANCEL') {
             this.showDialog = true;
             gorevise = true;
          }
         });
      }
      //console.log("showd: " + this.showDialog);
      if (!gorevise) {
        this.doSaveUser();
      }  
    },

    async doSaveUser() {
      //var gorevise = false;
      //var needAlert = true;
      this.$v.dataForm.$touch();
      //console.log(JSON.stringify(this.dataForm));

      if (this.$v.dataForm.$invalid) {
        return;
      }
      
      if (this.item.nw == null || this.item.nw == 'NaN') return;
      //console.log(this.item);

      if (this.scaleTimeError) return

// // POC begin //     
//       if (this.ccrLog.containerNo == "X" || this.ccrLog.containerNo == "0" ){
//           this.ccrLog.containerNo = this.dataForm.containerNo;
//       }
//       if (this.ccrLog.chassisNo == "X" || this.ccrLog.containerNo == "0" ){
//           this.ccrLog.chassisNo = this.dataForm.chassisNo;
//       }

//       if (this.dataForm.containerNo == null){
//           this.dataForm.containerNo = this.ccrLog.containerNo;
//       }
//       if (this.dataForm.chassisNo == null){
//           this.dataForm.chassisNo = this.ccrLog.chassisNo;
//       }


//       if (this.ccrLog.containerNo !=this.dataForm.containerNo  ){
//           this.ccrLog.containerNo = this.dataForm.containerNo;
//         }
//       if (this.ccrLog.plateNo != this.dataForm.driverLP){
//           this.ccrLog.plateNo = this.dataForm.driverLP;
//         }
// // POC end //  

      // if (this.scaleGwminmaxError && this.needAlert) {
      //    await this.doConfirmAlert("Gross weight needs between 48000 and 85000!").then ( (ret) =>{
      //     console.log("retVal: " + JSON.stringify(ret));
      //     this.needAlert = false;
      //     if (ret == 'CANCEL') 
      //        gorevise = true; 
      //    });
      // }
      // if (this.scaleTwminmaxError && this.needAlert) {
      //    var msg = "Tare weight needs between 25000 and 35000";
      //    if (this.scaleNwminmaxError) {
      //       msg += "; Net weight needs between 25000 and 50000";
      //    }
      //    msg += "!";
      //    await this.doConfirmAlert(msg).then ( (ret) =>{
      //     console.log("retVal: " + JSON.stringify(ret));
      //     this.needAlert = false;
      //     if (ret == 'CANCEL') 
      //        gorevise = true; 
      //    });
      // }
      //console.log("needAlert: " + this.needAlert);
      //console.log("gorevise: " + gorevise);
      //if (!gorevise) { 

      var selectDate = dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + dateFormat.time(moment().toDate());
      const autoWeight = this.getScaleControl(this.dataForm.scale);
      if (!autoWeight)
        {
          selectDate = "0000-00-00T00:00:00";
        }

        if (this.mode == "SWR") {
              // this.ccrLog.processType = "Inbound-20-Scale-Gross​";
              //console.log( moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time );
              this.load.gwDate = moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time;
              // this.load.gwDateWeb = dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + dateFormat.time(moment().toDate()),
              this.load.gwDateWeb = selectDate,
              this.load.vgmWeight = this.item.nw;
              this.load.gwYgNo = this.dataForm.ygNo;
              this.load.gwYgWeight = this.dataForm.ygWeight;
              this.load.containerNo = this.dataForm.containerNo;
              this.load.driverLP = this.dataForm.driverLP;
              const scale = this.dataForm.scale;
              const originalgw = this.dataForm.originalgw;
              this.showDialog = false;
              this.$store.commit("clearApiError");
              this.action(scale, originalgw);
        }

        if (this.mode == "STR") {
          // this.ccrLog.processType = "Inbound-50-Scale-Tare​";
          if (this.dataForm.ygNo != null && this.load.gwYgNo == null){
            this.scaleGwygError = true;
            return;
          };
          if (this.dataForm.ygNo == null && this.load.gwYgNo != null){
            this.scaleTwygError = true;
            return;
          };

          //console.log( moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time );
          this.load.twDate = moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time;
          // this.load.twDateWeb = dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + dateFormat.time(moment().toDate()),
          this.load.twDateWeb = selectDate,
          this.load.tareWeight = this.item.nw;
          this.load.twYgNo = this.dataForm.ygNo;
          this.load.twYgWeight = this.dataForm.ygWeight;
          const scale = this.dataForm.scale;
          const avm = (this.dataForm.avm && this.dataForm.avm != "")? this.dataForm.avm : 0;
          const moistdeductlbs = (this.dataForm.moistDeductLBS && this.dataForm.moistDeductLBS != "")? this.dataForm.moistDeductLBS : 0;
          const moistdeductper = (this.dataForm.moistDeductPercent && this.dataForm.moistDeductPercent != "")? this.dataForm.moistDeductPercent : 0;
          const drynet = (this.dataForm.dryNet && this.dataForm.dryNet != "")? this.dataForm.dryNet : 0;
          const wetnet = (this.dataForm.wetNet && this.dataForm.wetNet != "")? this.dataForm.wetNet : 0;
          const originalgw = this.dataForm.originalgw;
          //const originaltw = this.dataForm.originaltw;
          const originaltw = wetnet;
          const plasticWeight = this.plasticWeight;
          const palletCount = this.palletCount;
          const palletWeight = this.palletWeight;
          //console.log("return originalgw: " + originalgw + ", originaltw: " + originaltw);
          this.showDialog = false;
          this.$store.commit("clearApiError");
          this.action(scale, avm, moistdeductlbs, moistdeductper, wetnet, drynet, originalgw, originaltw, plasticWeight, palletCount, palletWeight);
        }
      //} else {
      //  this.showDialog = true;
      //  return;
      //}
// // POC begin //      
//       if (this.dataForm.scale == "2"){
//         this.ccrLog.seqNo = this.dataForm.seqNo;
//         this.ccrLog.inboundShipment = this.dataForm.inboundShipment;
//         await api.post('/api/w/ccr/data/updateCCRLog', this.ccrLog);
//       }  
// // POC end //           

    },
  },
};
</script>